import FilterList from '@mui/icons-material/FilterList';
import {
    Checkbox,
    Container,
    Divider,
    FormControl,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography
} from '@mui/material';
import { orange } from '@mui/material/colors';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';

import ErrorUtil from '@/util/ErrorUtil';
import { ESTRUTURA_NUMERO_PROCESSO_COM_CLASSE_PROCESSUAL } from '@/util/NumeroProcessoUtil';

import '../../css/cabecalho.css';
import ClienteEnvelopeService from '../../service/ClienteEnvelopeService';
import StorageUtil from '../../util/StorageUtil';
import ReactComponent from '../ReactComponent';

class AcompanhamentoSessao extends ReactComponent {
    clienteEnvelopeService = new ClienteEnvelopeService();

    ojcs = [];
    sessoesJulgamento = [];
    apregoados = [];
    sigla = '';
    idSessao = '';
    ocultarSessoesAnteriores = true;
    existeSessaoHoje = false;
    quantidadeSessoesHoje = 0;
    idsSessoesDeHoje = [];

    configurarClienteEnvelope = (sessao) => {
        const idSessoes = sessao.split('----');

        if (!this.clienteEnvelopeService.estaAcompanhandoSessoes(this.idSessao)) {
            this.clienteEnvelopeService.cancelarTodosAcompanhamentos();
            this.clienteEnvelopeService.acompanharSessoes(idSessoes, this.receberPregaoEnvelope.bind(this));
        }
    };

    handleChangeFiltroOcultarSessoes = () => {
        this.ocultarSessoesAnteriores = !this.ocultarSessoesAnteriores;
    };

    selecionarSessaoMaisRecenteComProcessos = () => {
        for (const sessaoJulgamento of this.sessoesJulgamento) {
            if (sessaoJulgamento.quantidadeTotalProcessos > 0) {
                this.idSessao = sessaoJulgamento.id;
                break;
            }
        }
    };

    handleChangeOJC = async (event) => {
        let sessaoSelecionada;
        this.reset();
        this.sigla = event.target.value;
        const sessoes = await this.sessaoService.recuperarSessoesJulgamentoAS(this.sigla);

        for (const sessao of sessoes) {
            if (!sessao.hoje) {
                continue;
            }

            this.idsSessoesDeHoje.push(sessao.id);
            sessaoSelecionada = sessao.id;
            this.setarSessaoHoje();
            this.quantidadeSessoesHoje++;
        }

        if (sessaoSelecionada && this.quantidadeSessoesHoje === 1) {
            this.setarIdSessao(sessaoSelecionada);
        } else if (sessoes && sessoes.length > 0 && sessoes[0]) {
            this.setarIdSessao(sessoes[0].id); //pega a sessão mais recente
        }
        runInAction(() => {
            this.sessoesJulgamento = sessoes;

            if (this.idSessao) {
                this.configurarEnvelope();
            }
        });
    };

    handleChangeSessao = (event) => {
        this.idSessao = event.target.value;
        this.configurarEnvelope();
    };

    setarSessaoHoje = () => {
        this.existeSessaoHoje = true;
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            clienteEnvelopeService: false,
            componentDidMount: false,
            carregarOJCs: action,
            recuperarPregao: action,
            configurarEnvelope: action,
            receberPregaoEnvelope: action,
            reset: action,
            getDescricaoSessao: false,
            render: false,
            renderMensagemExisteSessao: false,
            ojcs: observable,
            sessoesJulgamento: observable,
            apregoados: observable,
            sigla: observable,
            idSessao: observable,
            ocultarSessoesAnteriores: observable,
            existeSessaoHoje: observable,
            quantidadeSessoesHoje: observable,
            idsSessoesDeHoje: observable,
            configurarClienteEnvelope: action,
            handleChangeFiltroOcultarSessoes: action,
            selecionarSessaoMaisRecenteComProcessos: action,
            setarIdSessao: action,
            handleChangeOJC: action,
            handleChangeSessao: action,
            processosApregoados: computed,
            setarSessaoHoje: action
        });
    }

    componentDidMount() {
        this.carregarOJCs();
    }

    async carregarOJCs() {
        let ojcs;

        try {
            ojcs = await this.sessaoService.buscarOrgaosJulgadoresColegiadosAS();
        } catch (error) {
            this.mensagemStore.abrirMensagemErro(
                `Não foi possível carregar os Órgãos Julgadores Colegiados: ${ErrorUtil.montarMensagemErro(error)}`
            );
        } finally {
            runInAction(() => (this.ojcs = ojcs));
        }
    }

    async recuperarPregao(apregoado) {
        apregoado.dataHora = moment();
        const processoApregoado = await this.sessaoService.recuperarProcessoApregoadoAS(this.sigla);

        if (processoApregoado) {
            apregoado.relator = processoApregoado.relator ? processoApregoado.relator.sigla : '-';

            if (apregoado.cancelamento) {
                apregoado.apregoado = ['Cancelamento de Pregão'];
                apregoado.relator = '-';
            } else if (processoApregoado.planilha) {
                apregoado.apregoado = ['Planilha ' + processoApregoado.relator.sigla];
            }
            runInAction(() => {
                if (apregoado.apregoado) {
                    this.apregoados.push(apregoado);
                }
                localStorage.removeItem(StorageUtil.PREFIXO_NOME_STORAGE + this.sigla + '-' + this.idSessao);
                localStorage.setItem(
                    StorageUtil.PREFIXO_NOME_STORAGE + this.sigla + '-' + this.idSessao,
                    JSON.stringify(this.apregoados)
                );
                setTimeout(() => {
                    const element = document.querySelector('#tablePregao');
                    element.scrollIntoView({ block: 'end', inline: 'nearest' });
                }, 1000);
            });
        } else {
            this.mensagemStore.abrirMensagemErro('Não foi possível recuperar as informações do processo apregoado');
        }
    }

    setarIdSessao(idSessao) {
        this.idSessao = idSessao;
    }

    async configurarEnvelope() {
        try {
            await this.configurarClienteEnvelope(this.idSessao);
        } catch (error) {
            console.error(error);
            this.mensagemStore.abrirMensagemErro(
                'Não foi possível configurar o cliente do Envelope. Atualize a tela e tente novamente. Caso persista, contate o administrador.'
            );
        }

        const dadosStorage = localStorage.getItem(`SE-${this.sigla}-${this.idSessao}`);

        if (dadosStorage) {
            this.apregoados = JSON.parse(dadosStorage);
            setTimeout(() => {
                const element = document.querySelector('#tablePregao');

                if (element) {
                    element.scrollIntoView({ block: 'end', inline: 'nearest' });
                }
            }, 1000);
        } else {
            this.apregoados = [];
        }
    }

    async receberPregaoEnvelope(mensagem) {
        const pregao = JSON.parse(mensagem.data);

        if (!pregao.apregoado) {
            pregao.cancelamento = true;
        }

        const processoApregoado = {};
        const apregoado = pregao.apregoado && pregao.apregoado.length > 0 && pregao.apregoado[0];
        await this.recuperarPregao(pregao);

        if (apregoado) {
            const ehProcesso = ESTRUTURA_NUMERO_PROCESSO_COM_CLASSE_PROCESSUAL.test(apregoado);

            if (ehProcesso) {
                processoApregoado.numeroProcessoFormatado = apregoado;
            } else {
                processoApregoado.relator = {};
                const siglaecpf = apregoado.split('-');
                processoApregoado.relator.sigla = siglaecpf[0];
                processoApregoado.relator.cpf = siglaecpf[1];
            }
        }
    }

    get processosApregoados() {
        return this.apregoados.map((apregoado) => {
            return (
                <TableRow
                    hover
                    key={this.nextKey}
                >
                    <TableCell>{moment(apregoado.dataHora).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                    <TableCell>{apregoado.apregoado}</TableCell>
                    <TableCell>{apregoado.relator}</TableCell>
                </TableRow>
            );
        });
    }

    reset() {
        this.idsSessoesDeHoje = [];
        this.quantidadeSessoesHoje = 0;
        this.existeSessaoHoje = false;
        this.sessoesJulgamento = [];
        this.sigla = '';
        this.idSessao = '';
        this.clienteEnvelopeService.cancelarTodosAcompanhamentos();
        this.apregoados = [];
    }

    getDescricaoSessao(sessao) {
        return this.getDescricaoOpcaoSessao(sessao);
    }

    render() {
        return (
            <Container
                maxWidth="md"
                sx={{ marginTop: '40px', overflow: 'auto', marginBottom: '40px' }}
            >
                <Paper
                    elevation={6}
                    sx={{ marginBottom: '40px' }}
                >
                    <div style={{ marginLeft: '10px', marginTop: '40px', marginBottom: '40px' }}>
                        <div style={{ marginTop: '20px', maxHeight: '200px' }}>
                            <FormControl sx={{ maxHeight: '200px', marginTop: '20px' }}>
                                <InputLabel>Órgão Judicante</InputLabel>
                                <Select
                                    onChange={this.handleChangeOJC}
                                    sx={{ marginBottom: '20px', minWidth: '200px', maxHeight: '200px' }}
                                    value={this.sigla}
                                >
                                    {this.ojcs && this.ojcs.length > 0
                                        ? this.ojcs.map((ojc) => (
                                              <MenuItem
                                                  key={this.nextKey}
                                                  value={ojc.sigla}
                                              >
                                                  {ojc.descricao}
                                              </MenuItem>
                                          ))
                                        : null}
                                </Select>
                            </FormControl>
                        </div>
                        <div style={{ display: this.sessoesJulgamento.length > 0 ? 'flex' : 'none' }}>
                            <FormControl disabled={!this.existeSessaoHoje && this.ocultarSessoesAnteriores}>
                                <InputLabel>
                                    {this.sigla ? 'Sessão de Julgamento' : 'Selecione um órgão Judicante'}
                                </InputLabel>
                                <Select
                                    onChange={this.handleChangeSessao}
                                    sx={{ marginBottom: '20px', minWidth: '300px' }}
                                    value={this.idSessao}
                                >
                                    {this.ocultarSessoesAnteriores
                                        ? this.sessoesJulgamento &&
                                          this.sessoesJulgamento.length > 0 &&
                                          this.sessoesJulgamento.map((sessao) => {
                                              if (sessao.hoje) {
                                                  return (
                                                      <MenuItem
                                                          key={this.nextKey}
                                                          value={sessao.id}
                                                      >
                                                          {this.getDescricaoSessao(sessao)}
                                                      </MenuItem>
                                                  );
                                              }
                                              return null;
                                          })
                                        : this.sessoesJulgamento &&
                                          this.sessoesJulgamento.length > 0 &&
                                          this.sessoesJulgamento.map((sessao) => (
                                              <MenuItem
                                                  key={this.nextKey}
                                                  value={sessao.id}
                                              >
                                                  {this.getDescricaoSessao(sessao)}
                                              </MenuItem>
                                          ))}
                                </Select>
                            </FormControl>
                            {this.isComponenteHabilitado('filtroSessoesAnterioresAcompanhamento') && (
                                <Tooltip
                                    title={
                                        this.ocultarSessoesAnteriores
                                            ? 'Exibir sessões anteriores'
                                            : 'Ocultar sessões anteriores'
                                    }
                                >
                                    <Checkbox
                                        checked={this.ocultarSessoesAnteriores}
                                        checkedIcon={<FilterList sx={{ color: orange[400], opacity: '0.6' }} />}
                                        icon={<FilterList sx={{ color: 'grey' }} />}
                                        onChange={this.handleChangeFiltroOcultarSessoes}
                                        sx={{ padding: '6px' }}
                                    />
                                </Tooltip>
                            )}
                        </div>
                    </div>
                    <div
                        style={{
                            marginBottom: '5px',
                            marginTop: '40px',
                            marginLeft: '10px',
                            display: this.idSessao !== '' && this.sigla !== '' ? '' : 'none'
                        }}
                    >
                        {this.apregoados.length > 0 ? (
                            <div
                                style={{
                                    overflow: 'auto',
                                    maxHeight: '300px'
                                }}
                            >
                                <div>Histórico de Apregoamento:</div>
                                <TableContainer component={Paper}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="left">Data/Hora Pregão</TableCell>
                                                <TableCell align="left">Nº do Processo</TableCell>
                                                <TableCell align="left">Relator</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody id="tablePregao">{this.processosApregoados}</TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        ) : (
                            <div style={{ color: 'red', marginBottom: '20px' }}>
                                {this.renderMensagemExisteSessao()}
                            </div>
                        )}
                    </div>
                    <div
                        style={{
                            color: 'red',
                            marginTop: '40px',
                            fontSize: '13pt',
                            fontStyle: 'italic',
                            textAlign: 'justify',
                            marginLeft: '10px',
                            marginRight: '10px',
                            paddingBottom: '20px'
                        }}
                    >
                        <Divider />
                        <Typography>
                            * Os eventos são registrados apenas localmente, neste navegador.
                            <br />
                            Não constam registros de eventuais pregões que tenham sido realizados antes do primeiro
                            acesso à sessão selecionada ou enquanto o navegador tenha estado inativo.
                        </Typography>
                    </div>
                </Paper>
            </Container>
        );
    }

    renderMensagemExisteSessao() {
        return !this.existeSessaoHoje && this.ocultarSessoesAnteriores ? (
            <div>Hoje não existem sessões para o OJC selecionado.</div>
        ) : (
            <div>Aguardando apregoamento...</div>
        );
    }
}

export default inject('stores')(observer(AcompanhamentoSessao));
